import { useEffect } from "react";

export const useOverflow = (state) => {
  useEffect(() => {
    if (state) {
      // Prevent body scrolling when sidebar is open
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // Cleanup function
    return () => {
      document.body.style.overflow = "";
    };
  }, [state]);
};
